export enum ModulosEnum {
  HOME = 'HOME',
  HIGIENIZACAO = 'HIGIENIZACAO',
  ANALISE_DE_CREDITO = 'ANALISE_DE_CREDITO',
  NOTAS_FISCAIS = 'NOTAS_FISCAIS',
  ADMINISTRACAO = 'ADMINISTRACAO',
  INADIMPLENCIA = 'INADIMPLENCIA',
  API = 'API',
  CAMPANHAS = 'CAMPANHAS',
  PLANOS = 'PLANOS',
    
  RELATORIOS = 'RELATORIOS',
    RELATORIOS_DASHBOARDS_AVANCADOS = 'RELATORIOS_DASHBOARDS_AVANCADOS',
    RELATORIOS_REPASSES = 'RELATORIOS_REPASSES',
  
  BASE_DE_CONHECIMENTO = 'BASE_DE_CONHECIMENTO',
    BASE_DE_CONHECIMENTO_ARTIGOS = 'BASE_DE_CONHECIMENTO_ARTIGOS',
    BASE_DE_CONHECIMENTO_CATEGORIAS = 'BASE_DE_CONHECIMENTO_CATEGORIAS',

  GESTAO_FLUXO_DE_CAIXA = 'GESTAO_FLUXO_DE_CAIXA',
    GESTAO_FLUXO_DE_CAIXA_FLUXO_CAIXA = 'GESTAO_FLUXO_DE_CAIXA_FLUXO_CAIXA',
    GESTAO_FLUXO_DE_CAIXA_CAIXAS = 'GESTAO_FLUXO_DE_CAIXA_CAIXAS',

  CADASTROS = 'CADASTROS',
    CADASTROS_GRUPOS = 'CADASTROS_GRUPOS',
    CADASTROS_EMPRESAS = 'CADASTROS_EMPRESAS',
    CADASTROS_USUARIOS = 'CADASTROS_USUARIOS',
    CADASTROS_CLIENTES = 'CADASTROS_CLIENTES',
    CADASTROS_CATEGORIAS = 'CADASTROS_CATEGORIAS',
    CADASTROS_ESPECIE_PAGAMENTO = 'CADASTROS_ESPECIE_PAGAMENTO',
  
  
  SUPORTE = 'SUPORTE',
    SUPORTE_ONBOARDING_GUIADO_VIDEO = 'SUPORTE_ONBOARDING_GUIADO_VIDEO',
    SUPORTE_ONBOARDING_HUMANIZADO = 'SUPORTE_ONBOARDING_HUMANIZADO',
    SUPORTE_EMAIL = 'SUPORTE_EMAIL',
    SUPORTE_WHATSAPP = 'SUPORTE_WHATSAPP',
    SUPORTE_TREINAMENTO_ONLINE = 'SUPORTE_TREINAMENTO_ONLINE',


  EMISSAO_COBRANCAS = 'EMISSAO_COBRANCAS',
    EMISSAO_LINK_PAGAMENTO = 'EMISSAO_LINK_PAGAMENTO',
    EMISSAO_COBRANCAS_PIX = 'EMISSAO_COBRANCAS_PIX',
    EMISSAO_COBRANCAS_BOLETO = 'EMISSAO_COBRANCAS_BOLETO',
    EMISSAO_COBRANCAS_CARTAO_CREDITO = 'EMISSAO_COBRANCAS_CARTAO_CREDITO',
    EMISSAO_COBRANCAS_CARTAO_DEBITO = 'EMISSAO_COBRANCAS_CARTAO_DEBITO',



  SERASA = 'SERASA',
    SERASA_CONSULTA_AVANCADA = 'SERASA_CONSULTA_AVANCADA',
    SERASA_CONSULTA_BASICA = 'SERASA_CONSULTA_BASICA',
    SERASA_NEGATIVACAO = 'SERASA_NEGATIVACAO',

  AUTOMACAO_COMUNICACAO_COBRANCAS = 'AUTOMACAO_COMUNICACAO_COBRANCAS',
    AUTOMACAO_COMUNICACAO_COBRANCAS_EMAIL = 'AUTOMACAO_COMUNICACAO_COBRANCAS_EMAIL',
    AUTOMACAO_COMUNICACAO_COBRANCAS_SMS = 'AUTOMACAO_COMUNICACAO_COBRANCAS_SMS',
    AUTOMACAO_COMUNICACAO_COBRANCAS_WHATSAPP = 'AUTOMACAO_COMUNICACAO_COBRANCAS_WHATSAPP',

  COMUNICACAO_EM_LOTE = 'COMUNICACAO_EM_LOTE',
    COMUNICACAO_EM_LOTE_WHATSAPP = 'COMUNICACAO_EM_LOTE_WHATSAPP',
    COMUNICACAO_EM_LOTE_SMS = 'COMUNICACAO_EM_LOTE_SMS',
    COMUNICACAO_EM_LOTE_EMAIL = 'COMUNICACAO_EM_LOTE_EMAIL',




  SUPERADMIN = 'SUPERADMIN',
    SUPERADMIN_API = 'SUPERADMIN_API',
    SUPERADMIN_ENVIO_DE_NOTIFICACOES = 'SUPERADMIN_ENVIO_DE_NOTIFICACOES',
    SUPERADMIN_GESTAO = 'SUPERADMIN_GESTAO',
    SUPERADMIN_ATIVIDADE_CLIENTES = 'SUPERADMIN_ATIVIDADE_CLIENTES',
    SUPERADMIN_HISTORICO_BOLETOS = 'SUPERADMIN_HISTORICO_BOLETOS',
    SUPERADMIN_COMISSAO_VENDAS = 'SUPERADMIN_COMISSAO_VENDAS',
    SUPERADMIN_MOVIMENTACAO_PRODUTO = 'SUPERADMIN_MOVIMENTACAO_PRODUTO',
    SUPERADMIN_CONCILIACAO_BANCARIA = 'SUPERADMIN_CONCILIACAO_BANCARIA',
    SUPERADMIN_CONTROLE_CONSUMO_FORNECEDOR = 'SUPERADMIN_CONTROLE_CONSUMO_FORNECEDOR',
    SUPERADMIN_AREA_DEV = 'SUPERADMIN_AREA_DEV',
    SUPERADMIN_ADICIONAR_SALDO = 'SUPERADMIN_ADICIONAR_SALDO',
    SUPERADMIN_COMUNICACAO_EM_LOTE_WHATSAPP_DEV = 'SUPERADMIN_COMUNICACAO_EM_LOTE_WHATSAPP_DEV',
    SUPERADMIN_EMPRESAS = 'SUPERADMIN_EMPRESAS',
    SUPERADMIN_DOCUMENTACAO = 'SUPERADMIN_DOCUMENTACAO',
    SUPERADMIN_SERVICOS_CONTROLE = 'SUPERADMIN_SERVICOS_CONTROLE',
    SUPERADMIN_PLANOS = 'SUPERADMIN_PLANOS',
    SUPERADMIN_CAMPANHAS = 'SUPERADMIN_CAMPANHAS',
    SUPERADMIN_LOG_CRIACAO_CONTA = 'SUPERADMIN_LOG_CRIACAO_CONTA',
    SUPERADMIN_PARCEIROS = 'SUPERADMIN_PARCEIROS',
}
